var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5846 3.70262C18.7856 3.84178 18.9062 4.07062 18.9062 4.31493V14.7056C18.9062 15.0148 18.7145 15.29 18.4269 15.3983L13.2316 17.3774C13.0708 17.4393 12.8945 17.4424 12.7337 17.3867L7.04671 15.4941L2.0988 17.3805C1.86995 17.4671 1.61328 17.4362 1.41227 17.297C1.21126 17.1579 1.09375 16.929 1.09375 16.6847V6.29409C1.09375 5.98485 1.28239 5.70962 1.57308 5.60139L6.76839 3.62222C6.9292 3.56037 7.10547 3.55728 7.26628 3.61294L12.9533 5.50552L17.9012 3.61913C18.13 3.53254 18.3867 3.56346 18.5877 3.70262H18.5846ZM2.57812 6.80435V15.6085L6.28906 14.1953V5.3911L2.57812 6.80435ZM12.2266 15.6549V6.82909L7.77344 5.34471V14.1706L12.2266 15.6549ZM13.7109 15.6085L17.4219 14.1953V5.3911L13.7109 6.80435V15.6085Z",
    fill: "#101729"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.9b09a29048000d7e626950ed4fb579c0.svg";
export { ForwardRef as ReactComponent };